
const changeRentingPageCategoryReducer = (selectedRentingCategory = "0", action) => {
  if (action.type === "SELECTED_RENTING_CATEGORY") {
    return action.payload;
  }
  return selectedRentingCategory;
};

export default changeRentingPageCategoryReducer;
